module.exports = __webpack_public_path__ + "assets/fonts/Guroo-Producer.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/guroo-producer/fonts/Guroo-Producer.woff2
 ** module id = 1110
 ** module chunks = 0
 **/